export enum PosMode {
  SALE = "sale",
  PURCHASE = "purchase",
}
